export default function Footer() {
  return (
    <footer className="bg-black/90 py-6 text-center text-gray-400">
      &copy; {new Date().getFullYear()} Ebin Benny. All Rights Reserved.
    </footer>
  );
}
